import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/types";

export const getAllTypes = (params = {}) => {
  const query = {};
  if (params.status === "active" || params.status === "inactive") {
    query.status = params.status;
  }

  return jeepRallyApi.get(baseUrl, { params: query });
};

export const createType = (formData) => {
  return jeepRallyApi.post(baseUrl, formData);
};

export const updateType = (id, formData) => {
  return jeepRallyApi.patch(`${baseUrl}/${id}`, formData);
};

export const toggleTypeStatus = (id) => {
  return jeepRallyApi.patch(`${baseUrl}/${id}/status`);
};
